<table class="record-table" *ngIf="indexArr">
  <thead>
    <tr>
      <th class="record-header">出社</th>
      <th class="record-header">退社</th>
      <th class="record-header">外出</th>
      <th class="record-header">戻り</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let i of indexArr">
      <tr>
        <td class="normal-stamp">{{ arriveStamps[i] }}</td>
        <td class="normal-stamp">{{ leaveStamps[i] }}</td>
        <td class="normal-stamp">{{ temporaryLeaveStamps[i] }}</td>
        <td class="normal-stamp">{{ reenterStamps[i] }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>
